export var Delimiters = /*#__PURE__*/function (Delimiters) {
  Delimiters["priceWithDiscount"] = "${priceWithDiscount}";
  Delimiters["price"] = "${price}";
  Delimiters["cadence"] = "${cadence}";
  return Delimiters;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SubscriptionInfo/interfaces.js
// module id = 3997
// module chunks = 11